// Words for weekly learning (Hebrew, Yiddish, and other Jewish languages)
export const jewishWords = [
  {
    id: 'shalom',
    hebrew: 'שלום',
    transliteration: 'shalom',
    meaning: 'Peace, hello, goodbye',
    example: 'Shalom! How are you today?',
    category: 'greetings',
    language: 'Hebrew',
  },
  {
    id: 'balagan',
    hebrew: 'בלגן',
    transliteration: 'balagan',
    meaning: 'Chaos, mess, disorder',
    example: 'The kids\' room is a total balagan!',
    category: 'common',
    language: 'Hebrew',
  },
  {
    id: 'toda',
    hebrew: 'תודה',
    transliteration: 'toda',
    meaning: 'Thank you',
    example: 'Toda for helping me with dinner.',
    category: 'greetings',
    language: 'Hebrew',
  },
  {
    id: 'beseder',
    hebrew: 'בסדר',
    transliteration: 'beseder',
    meaning: 'Okay, alright, fine',
    example: 'Everything is beseder now.',
    category: 'common',
    language: 'Hebrew',
  },
  {
    id: 'mazal-tov',
    hebrew: 'מזל טוב',
    transliteration: 'mazal tov',
    meaning: 'Congratulations, good luck',
    example: 'Mazal tov on your new baby!',
    category: 'celebrations',
    language: 'Hebrew',
  },
  {
    id: 'chag-sameach',
    hebrew: 'חג שמח',
    transliteration: 'chag sameach',
    meaning: 'Happy holiday',
    example: 'Chag sameach for Rosh Hashanah!',
    category: 'celebrations',
    language: 'Hebrew',
  },
  {
    id: 'shabbat',
    hebrew: 'שבת',
    transliteration: 'shabbat',
    meaning: 'Sabbath, day of rest',
    example: 'We light candles on Shabbat.',
    category: 'traditions',
    language: 'Hebrew',
  },
  {
    id: 'mitzvah',
    hebrew: 'מצווה',
    transliteration: 'mitzvah',
    meaning: 'Good deed, commandment',
    example: 'Helping others is a mitzvah.',
    category: 'traditions',
    language: 'Hebrew',
  },
  {
    id: 'tzedakah',
    hebrew: 'צדקה',
    transliteration: 'tzedakah',
    meaning: 'Charity, righteousness',
    example: 'We give tzedakah to help others.',
    category: 'traditions',
    language: 'Hebrew',
  },
  {
    id: 'challah',
    hebrew: 'חלה',
    transliteration: 'challah',
    meaning: 'Braided bread for Shabbat',
    example: 'We bake challah every Friday.',
    category: 'food',
    language: 'Hebrew',
  },
  {
    id: 'shul',
    hebrew: 'שול',
    transliteration: 'shul',
    meaning: 'Synagogue',
    example: 'We go to shul on Saturday mornings.',
    category: 'places',
    language: 'Hebrew',
  },
  {
    id: 'bubbe',
    hebrew: 'בובה',
    transliteration: 'bubbe',
    meaning: 'Grandmother',
    example: 'My bubbe makes the best matzah ball soup.',
    category: 'family',
    language: 'Yiddish',
  },
  {
    id: 'zayde',
    hebrew: 'זיידע',
    transliteration: 'zayde',
    meaning: 'Grandfather',
    example: 'Zayde tells the best stories.',
    category: 'family',
    language: 'Yiddish',
  },
  {
    id: 'simcha',
    hebrew: 'שמחה',
    transliteration: 'simcha',
    meaning: 'Joy, celebration',
    example: 'The wedding was a great simcha!',
    category: 'celebrations',
    language: 'Hebrew',
  },
  {
    id: 'tikkun-olam',
    hebrew: 'תיקון עולם',
    transliteration: 'tikkun olam',
    meaning: 'Repairing the world',
    example: 'Volunteering is part of tikkun olam.',
    category: 'traditions',
    language: 'Hebrew',
  },
  {
    id: 'kiddush',
    hebrew: 'קידוש',
    transliteration: 'kiddush',
    meaning: 'Blessing over wine',
    example: 'We say kiddush on Shabbat.',
    category: 'traditions',
    language: 'Hebrew',
  },
  {
    id: 'hamotzi',
    hebrew: 'המוציא',
    transliteration: 'hamotzi',
    meaning: 'Blessing over bread',
    example: 'We say hamotzi before eating challah.',
    category: 'traditions',
    language: 'Hebrew',
  },
  {
    id: 'shalom-bayit',
    hebrew: 'שלום בית',
    transliteration: 'shalom bayit',
    meaning: 'Peace in the home',
    example: 'We work for shalom bayit in our family.',
    category: 'family',
    language: 'Hebrew',
  },
  {
    id: 'chesed',
    hebrew: 'חסד',
    transliteration: 'chesed',
    meaning: 'Kindness, loving-kindness',
    example: 'Showing chesed to others is important.',
    category: 'traditions',
    language: 'Hebrew',
  },
  {
    id: 'bracha',
    hebrew: 'ברכה',
    transliteration: 'bracha',
    meaning: 'Blessing',
    example: 'We say a bracha before eating.',
    category: 'traditions',
    language: 'Hebrew',
  },
  {
    id: 'shana-tova',
    hebrew: 'שנה טובה',
    transliteration: 'shana tova',
    meaning: 'Good year (New Year greeting)',
    example: 'Shana tova! Happy New Year!',
    category: 'celebrations',
    language: 'Hebrew',
  },
  {
    id: 'lchaim',
    hebrew: 'לחיים',
    transliteration: 'l\'chaim',
    meaning: 'To life (toast)',
    example: 'L\'chaim! Let\'s celebrate!',
    category: 'celebrations',
    language: 'Hebrew',
  },
  {
    id: 'shalom-aleichem',
    hebrew: 'שלום עליכם',
    transliteration: 'shalom aleichem',
    meaning: 'Peace be upon you (greeting)',
    example: 'Shalom aleichem! Welcome to our home.',
    category: 'greetings',
    language: 'Hebrew',
  },
  {
    id: 'baruch-hashem',
    hebrew: 'ברוך השם',
    transliteration: 'baruch hashem',
    meaning: 'Blessed be God, thank God',
    example: 'Baruch hashem, everyone is healthy.',
    category: 'traditions',
    language: 'Hebrew',
  },
  {
    id: 'mensch',
    hebrew: 'מענטש',
    transliteration: 'mensch',
    meaning: 'A good, honorable person',
    example: 'He\'s a real mensch - always helping others.',
    category: 'character',
    language: 'Yiddish',
  },
  {
    id: 'kvetch',
    hebrew: 'קוועטש',
    transliteration: 'kvetch',
    meaning: 'To complain, whine',
    example: 'Stop kvetching and help out!',
    category: 'common',
    language: 'Yiddish',
  },
  {
    id: 'nosh',
    hebrew: 'נאשן',
    transliteration: 'nosh',
    meaning: 'To snack, light meal',
    example: 'Let\'s nosh on some cookies.',
    category: 'food',
    language: 'Yiddish',
  },
  {
    id: 'schlep',
    hebrew: 'שלעפּ',
    transliteration: 'schlep',
    meaning: 'To drag, carry with effort',
    example: 'I had to schlep all these groceries up the stairs.',
    category: 'common',
    language: 'Yiddish',
  },
  {
    id: 'shpiel',
    hebrew: 'שפּיל',
    transliteration: 'shpiel',
    meaning: 'A long story, sales pitch',
    example: 'He gave me the whole shpiel about why I should buy it.',
    category: 'common',
    language: 'Yiddish',
  },
  {
    id: 'tchotchke',
    hebrew: 'טשאָטשקע',
    transliteration: 'tchotchke',
    meaning: 'A knick-knack, small decorative item',
    example: 'The shelf is full of tchotchkes.',
    category: 'common',
    language: 'Yiddish',
  },
  {
    id: 'oy-vey',
    hebrew: 'אוי וויי',
    transliteration: 'oy vey',
    meaning: 'Oh no, expression of dismay',
    example: 'Oy vey, I forgot the challah!',
    category: 'expressions',
    language: 'Yiddish',
  },
  {
    id: 'mishpacha',
    hebrew: 'משפחה',
    transliteration: 'mishpacha',
    meaning: 'Family',
    example: 'Our whole mishpacha is coming for dinner.',
    category: 'family',
    language: 'Hebrew',
  },
  {
    id: 'seder',
    hebrew: 'סדר',
    transliteration: 'seder',
    meaning: 'Order, Passover meal',
    example: 'We celebrate the Passover seder together.',
    category: 'traditions',
    language: 'Hebrew',
  },
  {
    id: 'haggadah',
    hebrew: 'הגדה',
    transliteration: 'haggadah',
    meaning: 'Passover story book',
    example: 'We read from the haggadah during seder.',
    category: 'traditions',
    language: 'Hebrew',
  },
  {
    id: 'matzah',
    hebrew: 'מצה',
    transliteration: 'matzah',
    meaning: 'Unleavened bread',
    example: 'We eat matzah during Passover.',
    category: 'food',
    language: 'Hebrew',
  },
  {
    id: 'sukkah',
    hebrew: 'סוכה',
    transliteration: 'sukkah',
    meaning: 'Temporary hut for Sukkot',
    example: 'We eat meals in the sukkah during Sukkot.',
    category: 'traditions',
    language: 'Hebrew',
  },
  {
    id: 'menorah',
    hebrew: 'מנורה',
    transliteration: 'menorah',
    meaning: 'Candelabra, Hanukkah lamp',
    example: 'We light the menorah each night of Hanukkah.',
    category: 'traditions',
    language: 'Hebrew',
  },
  {
    id: 'dreidel',
    hebrew: 'סביבון',
    transliteration: 'dreidel',
    meaning: 'Spinning top for Hanukkah',
    example: 'The kids love playing dreidel.',
    category: 'traditions',
    language: 'Hebrew',
  },
  {
    id: 'latke',
    hebrew: 'לטקה',
    transliteration: 'latke',
    meaning: 'Potato pancake',
    example: 'We make latkes for Hanukkah.',
    category: 'food',
    language: 'Hebrew',
  },
  {
    id: 'shofar',
    hebrew: 'שופר',
    transliteration: 'shofar',
    meaning: 'Ram\'s horn',
    example: 'We hear the shofar on Rosh Hashanah.',
    category: 'traditions',
    language: 'Hebrew',
  },
  {
    id: 'tallit',
    hebrew: 'טלית',
    transliteration: 'tallit',
    meaning: 'Prayer shawl',
    example: 'He wears a tallit during morning prayers.',
    category: 'traditions',
    language: 'Hebrew',
  },
  {
    id: 'kippah',
    hebrew: 'כיפה',
    transliteration: 'kippah',
    meaning: 'Head covering, yarmulke',
    example: 'He wears a kippah in shul.',
    category: 'traditions',
    language: 'Hebrew',
  },
  {
    id: 'mezuzah',
    hebrew: 'מזוזה',
    transliteration: 'mezuzah',
    meaning: 'Doorpost scroll',
    example: 'We have a mezuzah on our front door.',
    category: 'traditions',
    language: 'Hebrew',
  },
  {
    id: 'tzedek',
    hebrew: 'צדק',
    transliteration: 'tzedek',
    meaning: 'Justice, righteousness',
    example: 'We work for tzedek in the world.',
    category: 'traditions',
    language: 'Hebrew',
  },
  {
    id: 'shalom-bayit',
    hebrew: 'שלום בית',
    transliteration: 'shalom bayit',
    meaning: 'Peace in the home',
    example: 'We create shalom bayit through kindness.',
    category: 'family',
    language: 'Hebrew',
  },
  {
    id: 'ruach',
    hebrew: 'רוח',
    transliteration: 'ruach',
    meaning: 'Spirit, wind',
    example: 'The ruach of the holiday fills our home.',
    category: 'traditions',
    language: 'Hebrew',
  },
  {
    id: 'neshama',
    hebrew: 'נשמה',
    transliteration: 'neshama',
    meaning: 'Soul',
    example: 'Every person has a neshama.',
    category: 'traditions',
    language: 'Hebrew',
  },
  {
    id: 'tov',
    hebrew: 'טוב',
    transliteration: 'tov',
    meaning: 'Good',
    example: 'That\'s tov! I\'m glad to hear it.',
    category: 'common',
    language: 'Hebrew',
  },
  {
    id: 'lo',
    hebrew: 'לא',
    transliteration: 'lo',
    meaning: 'No',
    example: 'Lo, I don\'t want that.',
    category: 'common',
    language: 'Hebrew',
  },
  {
    id: 'ken',
    hebrew: 'כן',
    transliteration: 'ken',
    meaning: 'Yes',
    example: 'Ken, I would love to come!',
    category: 'common',
    language: 'Hebrew',
  },
];

// Get word of the day (same word for the entire day, changes next day)
export function getWordOfTheDay() {
  const today = new Date();
  const dateString = `${today.getFullYear()}-${today.getMonth()}-${today.getDate()}`;
  
  // Use date as seed for consistent word per day
  let hash = 0;
  for (let i = 0; i < dateString.length; i++) {
    hash = ((hash << 5) - hash) + dateString.charCodeAt(i);
    hash = hash & hash; // Convert to 32-bit integer
  }
  
  const index = Math.abs(hash) % jewishWords.length;
  return jewishWords[index];
}

// Get a random word
export function getRandomWord() {
  return jewishWords[Math.floor(Math.random() * jewishWords.length)];
}

// Get word by ID
export function getWordById(id) {
  return jewishWords.find(word => word.id === id);
}

